export const reportInvoiceListTypes = {
  GET_REPORT_INVOICE_LIST: 'GET_REPORT_INVOICE_LIST',
  SET_REPORT_INVOICE_LIST_FILTERS: 'SET_REPORT_INVOICE_LIST_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};
